module.exports = __webpack_public_path__ + "static/media/LovingParentGuideBook_cover.950fbd9d.jpg";